var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.285 11.284L16 19.571l-8.285-8.288a1.01 1.01 0 10-1.429 1.43l8.999 9.002a1.009 1.009 0 001.428 0l8.999-9.002a1.01 1.01 0 10-1.427-1.429z"}));
}

Arrow.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Arrow;

Arrow.default = Arrow;
